import { Box, Checkbox, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let lunesIn = '';
let martesIn = '';
let miercolesIn = '';
let juevesIn = '';
let viernesIn = '';
let sabadoIn = '';

class HorarioVariado extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            consulta: false,
            numeroNombre: [],
            codigosMovimientos: [],
            modalActualizar: false,
            horasEntrada: [],
            horasSalida: [],
            horariosFuncionario: [],
            modalBorrar: false,

            busqueda: {
                numeroFuncionarioBusqueda: '',
            },

            horarios: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                lunes: '0',
                martes: '0',
                miercoles: '0',
                jueves: '0',
                viernes: '0',
                sabado: '0',
                lunesS: '0',
                martesS: '0',
                miercolesS: '0',
                juevesS: '0',
                viernesS: '0',
                sabadoS: '0',
                horasEfectivas: '0',
                desde: '',
                especial: false,
            },

            horasEditar: {
                idHorarioFuncionario: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                lunesEntrada: '',
                martesEntrada: '',
                miercolesEntrada: '',
                juevesEntrada: '',
                viernesEntrada: '',
                horasEfectivas: '',
                desde: '',
                activo: '',
            },
        }
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioMovimiento = this.manejarEnvioMovimiento.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.obtenerCal = this.obtenerCal.bind(this);
        this.manejarCambioEditar = this.manejarCambioEditar.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
        this.manejarCambiosDatosHE = this.manejarCambiosDatosHE.bind(this);
    }

    async componentDidMount(){
        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_codigosMovimientos.php`);
        const datos = await respuesta.json();
        this.setState({
            codigosMovimientos: datos,
        });

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntrada: datosEntrada,
        });

        const sal = await fetch(`${Constantes.RUTA_API}/obtener_salidas.php`);
        const datosSalida = await sal.json();
        this.setState({
            horasSalida: datosSalida,
        });
    }

    render(){
        return (
            <>
                <Container>
                    <h3>Horario Semanal</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <form className='formulario1'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.5}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambioNumFun} type="number" /></Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                    <Container>
                        {this.state.consulta ? null : <FormControlLabel label='HORARIO ESPECIAL' control={<Checkbox checked={this.state.horarios.especial} onChange={this.manejarCambiosDatosHE} id='especial' inputProps={{ 'aria-label': 'controlled' }} /> }/>}
                        {this.state.horarios.especial
                        ?
                            null
                        :
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            {this.state.consulta ? null : <StyledTableCell width={'10%'}>Número</StyledTableCell>}
                                            {this.state.consulta ? null : <StyledTableCell >Nombre</StyledTableCell>}
                                            <StyledTableCell width={'16%'}>Lunes</StyledTableCell>
                                            <StyledTableCell width={'16%'}>Martes</StyledTableCell>
                                            <StyledTableCell width={'16%'}>Miercoles</StyledTableCell>
                                            <StyledTableCell width={'16%'}>Jueves</StyledTableCell>
                                            <StyledTableCell width={'16%'}>Viernes</StyledTableCell>
                                            {this.state.consulta ? <StyledTableCell width={'16%'}>Sabados</StyledTableCell> : null}
                                            <StyledTableCell width={'10%'}>Horas Efectivas</StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                            {this.state.consulta ? <StyledTableCell></StyledTableCell> : ''}
                                            {/*this.state.consulta ? <StyledTableCell></StyledTableCell> : ''*/}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/*Listo todo lo que voy agregando*/}
                                        {this.state.horariosFuncionario.map((datosAg) => (
                                            <StyledTableRow key={datosAg.idHorarioFuncionario}>
                                                {/*<StyledTableCell>{datosAg.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{datosAg.nombreFuncionario}</StyledTableCell>*/}
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.lunesEntrada === name.idEntrada){
                                                        lunesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{lunesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.martesEntrada === name.idEntrada){
                                                        martesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{martesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.miercolesEntrada === name.idEntrada){
                                                        miercolesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{miercolesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.juevesEntrada === name.idEntrada){
                                                        juevesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{juevesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.viernesEntrada === name.idEntrada){
                                                        viernesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{viernesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.sabadoEntrada === name.idEntrada){
                                                        sabadoIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{sabadoIn}</StyledTableCell>
                                                <StyledTableCell>{datosAg.horasEfectivas}</StyledTableCell>
                                                <StyledTableCell>{ datosAg.desde.substring(8,10) + '/' + datosAg.desde.substring(5,7) + '/' + datosAg.desde.substring(0,4)}</StyledTableCell>
                                                {/*<StyledTableCell><button className="btn btn-danger mx-2" onClick={() => this.manejarEdicion(datosAg)}>Editar</button></StyledTableCell>*/}
                                                {datosAg.activo ? <StyledTableCell></StyledTableCell> : <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosAg)}>Borrar</button></StyledTableCell>}
                                            </StyledTableRow>
                                        ))}
                                        {/*Acá dejo siempre un espacio para seguir agregando*/}
                                        {this.state.consulta ? '' :
                                        <StyledTableRow>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.horarios.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>{this.state.horarios.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='lunes' value={this.state.horarios.lunes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='martes' value={this.state.horarios.martes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='miercoles' value={this.state.horarios.miercoles} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='jueves' value={this.state.horarios.jueves} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='viernes' value={this.state.horarios.viernes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='horasEfectivas' value={this.state.horarios.horasEfectivas} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.horarios.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        </StyledTableRow>}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }
                        {this.state.horarios.especial
                        ?
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            {this.state.consulta ? null : <StyledTableCell width={'10%'}>Número</StyledTableCell>}
                                            {this.state.consulta ? null : <StyledTableCell >Nombre</StyledTableCell>}
                                            <StyledTableCell width={'16%'}>Lunes</StyledTableCell>
                                            <StyledTableCell width={'16%'}>Martes</StyledTableCell>
                                            <StyledTableCell width={'16%'}>Miercoles</StyledTableCell>
                                            <StyledTableCell width={'16%'}>Jueves</StyledTableCell>
                                            <StyledTableCell width={'16%'}>Viernes</StyledTableCell>
                                            {this.state.horarios.especial ? <StyledTableCell width={'16%'}>Sabados</StyledTableCell> : <StyledTableCell width={'10%'}>Horas Efectivas</StyledTableCell>}
                                            <StyledTableCell>HORAS EFECTIVAS</StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                            {this.state.consulta ? <StyledTableCell></StyledTableCell> : ''}
                                            {/*this.state.consulta ? <StyledTableCell></StyledTableCell> : ''*/}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/*Listo todo lo que voy agregando*/}
                                        {this.state.horariosFuncionario.map((datosAg) => (
                                            <StyledTableRow key={datosAg.idHorarioFuncionario}>
                                                {/*<StyledTableCell>{datosAg.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{datosAg.nombreFuncionario}</StyledTableCell>*/}
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.lunesEntrada === name.idEntrada){
                                                        lunesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{lunesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.martesEntrada === name.idEntrada){
                                                        martesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{martesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.miercolesEntrada === name.idEntrada){
                                                        miercolesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{miercolesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.juevesEntrada === name.idEntrada){
                                                        juevesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{juevesIn}</StyledTableCell>
                                                {this.state.horasEntrada.map((name) => {
                                                    if(datosAg.viernesEntrada === name.idEntrada){
                                                        viernesIn = name.descripcion;
                                                }})}
                                                <StyledTableCell>{viernesIn}</StyledTableCell>
                                                <StyledTableCell>{datosAg.horasEfectivas}</StyledTableCell>
                                                <StyledTableCell>{ datosAg.desde.substring(8,10) + '/' + datosAg.desde.substring(5,7) + '/' + datosAg.desde.substring(0,4)}</StyledTableCell>
                                                {/*<StyledTableCell><button className="btn btn-danger mx-2" onClick={() => this.manejarEdicion(datosAg)}>Editar</button></StyledTableCell>*/}
                                                {datosAg.activo ? <StyledTableCell></StyledTableCell> : <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosAg)}>Borrar</button></StyledTableCell>}
                                            </StyledTableRow>
                                        ))}
                                        {/*Acá dejo siempre un espacio para seguir agregando*/}
                                        {this.state.consulta ? '' :
                                        <StyledTableRow>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.horarios.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>{this.state.horarios.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='lunes' value={this.state.horarios.lunes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='martes' value={this.state.horarios.martes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='miercoles' value={this.state.horarios.miercoles} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='jueves' value={this.state.horarios.jueves} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='viernes' value={this.state.horarios.viernes} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='sabado' value={this.state.horarios.sabado} onChange={this.manejarCambiosDatos}>
                                                    <option value={''}>ENTRADA</option>
                                                        {this.state.horasEntrada.map((name) =>
                                                        <option
                                                        key={name.idEntrada}
                                                        value={name.idEntrada}
                                                        >{name.descripcion}
                                                    </option>
                                                    )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='horasEfectivas' value={this.state.horarios.horasEfectivas} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desde' value={this.state.horarios.desde} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        </StyledTableRow>}
                                        {this.state.consulta
                                        ?
                                            ''
                                        :
                                            <StyledTableRow>
                                                <StyledTableCell>SALIDA</StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='lunesS' value={this.state.horarios.lunesS} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>SALIDA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='martesS' value={this.state.horarios.martesS} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>SALIDA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='miercolesS' value={this.state.horarios.miercolesS} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>SALIDA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='juevesS' value={this.state.horarios.juevesS} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>SALIDA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='viernesS' value={this.state.horarios.viernesS} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>SALIDA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <select style={{width:"50%", border:"2px solid #D6EAF8", float: 'left'}} id='sabadoS' value={this.state.horarios.sabadoS} onChange={this.manejarCambiosDatos}>
                                                        <option value={''}>SALIDA</option>
                                                            {this.state.horasEntrada.map((name) =>
                                                            <option
                                                            key={name.idEntrada}
                                                            value={name.idEntrada}
                                                            >{name.descripcion}
                                                        </option>
                                                        )}
                                                    </select>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        :
                            null
                        }
                        {this.state.consulta ? '' : <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioMovimiento}>Agregar</button>}
                        {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : ''}
                        <br/>
                        <br/>
                    </Container>
                </Container>
                <Modal open={this.state.modalActualizar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                        <h3 style={{textAlign:'center'}}>Editar Movimiento</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={6}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>{this.state.horasEditar.numeroFuncionario}</Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Lunes</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='lunesEntrada' value={this.state.horasEditar.lunesEntrada} onChange={this.manejarCambioEditar}>
                                        <option value={''}>ENTRADA</option>
                                            {this.state.horasEntrada.map((name) =>
                                            <option
                                            key={name.idEntrada}
                                            value={name.idEntrada}
                                            >{name.descripcion}
                                        </option>
                                        )}
                                    </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Mates</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='martesEntrada' value={this.state.horasEditar.martesEntrada} onChange={this.manejarCambioEditar}>
                                        <option value={''}>ENTRADA</option>
                                            {this.state.horasEntrada.map((name) =>
                                            <option
                                            key={name.idEntrada}
                                            value={name.idEntrada}
                                            >{name.descripcion}
                                        </option>
                                        )}
                                    </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Miercoles</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='miercolesEntrada' value={this.state.horasEditar.miercolesEntrada} onChange={this.manejarCambioEditar}>
                                        <option value={''}>ENTRADA</option>
                                            {this.state.horasEntrada.map((name) =>
                                            <option
                                            key={name.idEntrada}
                                            value={name.idEntrada}
                                            >{name.descripcion}
                                        </option>
                                        )}
                                    </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Jueves</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='juevesEntrada' value={this.state.horasEditar.juevesEntrada} onChange={this.manejarCambioEditar}>
                                        <option value={''}>ENTRADA</option>
                                            {this.state.horasEntrada.map((name) =>
                                            <option
                                            key={name.idEntrada}
                                            value={name.idEntrada}
                                            >{name.descripcion}
                                        </option>
                                        )}
                                    </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Viernes</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='viernesEntrada' value={this.state.horasEditar.viernesEntrada} onChange={this.manejarCambioEditar}>
                                        <option value={''}>ENTRADA</option>
                                            {this.state.horasEntrada.map((name) =>
                                            <option
                                            key={name.idEntrada}
                                            value={name.idEntrada}
                                            >{name.descripcion}
                                        </option>
                                        )}
                                    </select>
                                    </Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={6}>
                                    <Item>Viernes</Item>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='horasEfectivas' value={this.state.horasEditar.horasEfectivas} onChange={this.manejarCambioEditar} type="number" /></Item>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={2}>
                                    
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
                <Modal open={this.state.modalBorrar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                        <h3 style={{textAlign:'center'}}>¿Confirmar Baja Horario Semanal?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
            </>
        )//Final Return
    }//Final Render

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.busqueda.numeroFuncionarioBusqueda === ''){
            this.setState({
                errores: "DEBE INGRESAR UN NUMERO DE FUNCIONARIO!",
            });
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify(this.state.busqueda);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_horarioFuncionario.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            if(exito){
                if(exito.length !== 0){
                    this.setState({
                        consulta: true,
                        horariosFuncionario: exito,
                    })
                }else{
                    this.setState({
                        consulta: false,
                        horariosFuncionario: [],
                        errores: 'No existen movimientos para el número de funcionario ingresado!',
                    });
                }
            }
        }
    }

    manejarCambioNumFun(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const horariosActualizado = state.horarios;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    horariosActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    horariosActualizado['nombreFuncionario'] = '';
                }
                });
            }
            horariosActualizado[clave] = valor;
            return{
                horarios: horariosActualizado,
            };
        })
    }

    async manejarEnvioMovimiento(e){
        e.preventDefault();
        let cont = 0;
        if(this.state.horarios.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario!',
            });
        }else if(this.state.horarios.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un numero de funcionario valido',
            });
        }else if(this.state.horarios.horasEfectivas === '0'){
            this.setState({
                errores: 'Debe ingresar las horas efectivas',
            });
        }else if(this.state.horarios.desde === ''){
            this.setState({
                errores: 'Debe ingresar la fecha DESDE',
            });
        }else{ 
            if(this.state.horarios.lunes === '0'){
                cont = cont + 1;
            }
            if(this.state.horarios.martes === '0'){
                cont = cont + 1;
            }
            if(this.state.horarios.miercoles === '0'){
                cont = cont + 1;
            }
            if(this.state.horarios.jueves === '0'){
                cont = cont + 1;
            }
            if(this.state.horarios.viernes === '0'){
                cont = cont + 1;
            }
            if(cont > 1){
                this.setState({
                    errores: 'No pueden quedar dos dias libres!',
                });;
            }else{

                const cargaUtil = JSON.stringify(this.state.horarios);
                //Voy a probar hacer los controles en la logica
    
                const control = await fetch(`${Constantes.RUTA_API}/guardar_horarioVariado.php`,{
                    method: 'POST',
                    body: cargaUtil,
                })
                const res = await control.json();
                this.setState({
                    errores: res,
                });
    
                //-----------------------------------------------------------------
                if(res === 'ok'){
                    this.setState({
                        notificaciones: 'Los datos fueron ingresados correctamente',
                        errores: null,
                        horarios: {
                            numeroFuncionario: '',
                            nombreFuncionario: '',
                            lunes: '0',
                            martes: '0',
                            miercoles: '0',
                            jueves: '0',
                            viernes: '0',
                            sabado: '0',
                            lunesS: '0',
                            martesS: '0',
                            miercolesS: '0',
                            juevesS: '0',
                            viernesS: '0',
                            sabadoS: '0',
                            horasEfectivas: '0',
                            desde: '',
                            especial: false,
                        },
                    });
                    //}
                }
                //------------------------------------------------------------------------
            }
        }
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            horariosFuncionario: [],
            errores: null,
            notificaciones: null,
        });
    }

    manejarEdicion(dato){
        this.setState({
            modalActualizar: true,
            horasEditar: dato,
            notificaciones: null,
        });
    }


    async obtenerCal(e){
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_horarioFuncionario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            horariosFuncionario: exito,
        });
    } 

    cerrarModal(e){
        e.preventDefault();
        this.obtenerCal();
        this.setState({
            modalActualizar: false,
            modalBorrar: false,
        });
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify(this.state.horasEditar);

        const respuesta = await fetch(`${Constantes.RUTA_API}/editar_horarioVariado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            modalActualizar: false,
        });
        if(exito === 'ok'){
            this.setState({
                notificaciones: 'Los datos fueron ingresados correctamente',
                modalActualizar: false,
                errores: null,
            });
        }
    }

    manejarCambioEditar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const horasEditarActualizado = state.horasEditar;

            horasEditarActualizado[clave] = valor;
            return {
                horasEditar: horasEditarActualizado,
            }
        })
    }

    manejarBorrar(dato){
        this.setState({
            modalBorrar: true,
            horasEditar: dato,
            notificaciones: null,
        });
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify(this.state.horasEditar);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_horario.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito){
            let contador = 0;
            const arr = this.state.horariosFuncionario;
            arr.map((name) => {
                if(this.state.horasEditar.idHorarioFuncionario === name.idHorarioFuncionario){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrar: false,
                horariosFuncionario: arr,
            });
        }
    }

    manejarCambiosDatosHE(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.checked;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const funcionarioActualizado = state.horarios;
            funcionarioActualizado[clave] = valor;
            return{
                horarios: funcionarioActualizado,
            };
        })
    }
}

export default HorarioVariado;